import { render, staticRenderFns } from "./resImportRecord.vue?vue&type=template&id=bd08682e&scoped=true&"
import script from "./resImportRecord.vue?vue&type=script&lang=js&"
export * from "./resImportRecord.vue?vue&type=script&lang=js&"
import style0 from "./resImportRecord.vue?vue&type=style&index=0&id=bd08682e&prod&lang=css&"
import style1 from "./resImportRecord.vue?vue&type=style&index=1&id=bd08682e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd08682e",
  null
  
)

export default component.exports